import { Action } from 'redux';
import { ErrorWrapper } from 'store/base';

export const REDUCER_NAME__CUSTOMERS = 'customers';

export interface CustomerListReduxState {
  type?: string;
  loading: boolean;
  errorWrapper?: ErrorWrapper;
}

const defaultState: CustomerListReduxState = {
  loading: false,
};

export default (
  state: CustomerListReduxState = defaultState,
  action: Action,
): CustomerListReduxState => {
  return state;
};
